import { Selector, createSelector } from '@reduxjs/toolkit'
import { GlobalState } from 'store'
import { DefaultCollateralIdentifierType, UserPreference } from 'api'
import { OptionGroup } from 'view/components/options'
import { createAuthorisedUserSelector } from './connectionSelectors'
import { isEqual } from 'lodash'

export function createUserPreferenceSelector(): Selector<GlobalState, UserPreference> {
  return createSelector(createAuthorisedUserSelector(), authorisedUser => authorisedUser.userPreference, {
    memoizeOptions: {
      resultEqualityCheck: isEqual
    }
  })
}

export const userPreferenceSelector: Selector<GlobalState, UserPreference> = createSelector(
  createAuthorisedUserSelector(),
  authorisedUser => authorisedUser.userPreference,
  {
    memoizeOptions: {
      resultEqualityCheck: isEqual
    }
  }
)

export const userPreferenceOtwDurationSelector = createSelector(
  userPreferenceSelector,
  userPreference => userPreference.otwDurationMinsDefault
)

export function createUserCounterpartyOptionGroupsSelector(): Selector<GlobalState, OptionGroup<string>[]> {
  return createSelector(userPreferenceSelector, userPreference =>
    userPreference.counterpartyGroups.map(group => ({
      id: group.id,
      name: group.description,
      members: group.counterpartyIds
    }))
  )
}

export const createIsInitiatedNegotiationCounterpartyViewEnabled = (): Selector<GlobalState, boolean> =>
  createSelector(userPreferenceSelector, userPreference => userPreference.counterPartyGridView === true)

export const defaultCollateralIdentifierTypeSelector: Selector<GlobalState, DefaultCollateralIdentifierType> = createSelector(
  userPreferenceSelector,
  userPreference => userPreference.defaultCollateralIdentifierType
)
